const instance = ($el: HTMLElement) => {
  if (
    !navigator.share
    || !$el.hasAttribute("data-title")
    || !$el.hasAttribute("data-url")
  ) {
    if ($el.nextElementSibling?.classList.contains("js-share-fallback")) {
      $el.nextElementSibling?.classList.add("active");
    }
    $el.remove();
    return;
  }

  $el.addEventListener("click", (event: MouseEvent) => {
    event.preventDefault();

    navigator
      .share({
        title: $el.getAttribute("data-title")!,
        url: $el.getAttribute("data-url")!,
      })
      .catch(error => console.error("Error sharing", error));

    return false;
  });
};

export default () => {
  const $el = document.querySelectorAll<HTMLElement>(".js-share");

  $el.forEach(($element) => {
    instance($element);
  });
};
